

import React from "react";
import "../css/Sellos.css";

import Sello1 from "../img/creatividad.png";
import Sello2 from "../img/socioambiental.png";
import Sello3 from "../img/cultural.png";

const Sellos = () => {

    return (

        <section
            id="sellos-component"
            className="esc-sellos-section"
        >

            <div className="esc-sellos-container">

                <h2 className="esc-sellos-title">

                    Sellos

                </h2>

                <p className="esc-sellos-subtitle">

                    Nuestros Sellos son...

                </p>

                <div className="esc-sellos-grid">

                    {/* ================= IDENTIDAD Y CREATIVIDAD ================= */}

                    <article className="esc-sellos-card esc-sellos-red">

                        <h3 className="esc-sellos-card-title">

                            Identidad y Creatividad

                        </h3>

                        <img
                            src={Sello1}
                            alt="Sello Identidad y Creatividad"
                            className="esc-sellos-icon"
                        />

                        <p className="esc-sellos-description">

                            Reconocemos la diversidad de intereses de nuestros estudiantes, razón por la cual hemos sintetizado las expresiones artísticas,
                            deportivas y habilidades lingüísticas para dar cuenta de un proceso formativo de desarrollo personal y social. Abordamos
                            la identidad como una construcción de sentido, proceso continuo que configura al sujeto como ser autónomo o heterónomo,
                            que pone de relieve sus referentes sociales, culturales y geográficos, dando a conocer el modo en que el sujeto se coloca frente
                            al mundo o toma lugar en él. Al mismo tiempo, consideramos la creatividad como una destreza necesaria de fortalecer, mediante
                            experiencias pedagógicas que desarrollen en las y los estudiantes capacidades para adaptarse a nuevas situaciones y dar múltiples
                            soluciones a los problemas. Este sello implica que cada individuo, en relación con otros, pueda responsabilizarse de sí mismo
                            y realizar su proyecto personal.

                        </p>

                    </article>

                    {/* ================= CONCIENCIA SOCIOAMBIENTAL ================= */}

                    <article className="esc-sellos-card esc-sellos-blue">

                        <h3 className="esc-sellos-card-title">

                            Conciencia Socioambiental

                        </h3>

                        <img
                            src={Sello2}
                            alt="Sello Conciencia Socioambiental"
                            className="esc-sellos-icon"
                        />

                        <p className="esc-sellos-description">

                            Promovemos la conciencia y reflexión sobre el cuidado medioambiental generando hábitos y conductas sustentables, valorando
                            y respetando el entorno. Pero al mismo tiempo formamos para comprender que los problemas socioambientales están afectando
                            los modos, los estilos y la calidad de vida, por lo cual se debe educar desde las experiencias próximas a su ambiente y
                            trabajar por la defensa del territorio cercano. Para nuestra escuela, una conciencia socioambiental es una conciencia territorial,
                            la cual busca articular a la ciudadanía en nuevas formas de participación.

                        </p>

                    </article>

                    {/* ================= INTERCULTURALIDAD ================= */}

                    <article className="esc-sellos-card esc-sellos-red">

                        <h3 className="esc-sellos-card-title">

                            Interculturalidad

                        </h3>

                        <img
                            src={Sello3}
                            alt="Sello Interculturalidad"
                            className="esc-sellos-icon"
                        />

                        <p className="esc-sellos-description">

                            Nuestra escuela, busca construir una cultura que da valor a la riqueza de la diversidad de toda la comunidad, por
                            medio de una convivencia respetuosa entre las personas y las comunidades. Se promoverá formativamente
                            estrategias que den respuesta a las necesidades que presentan los diferentes contextos sociales de las personas,
                            en base al diálogo, sin prejuicios ni exclusiones. Reconocemos a la escuela como un espacio de interacción cultural,
                            la cual vive permanentemente procesos de relación y mediación, en condiciones de respeto, legitimidad, simetría,
                            equidad e igualdad. Mineduc, cita la interculturalidad como “el espacio en que se favorece la creación de nuevas
                            formas de convivencia ciudadana entre todas y todos, sin distinción de nacionalidad u origen, que enriquece las
                            construcciones del mundo, asegurando el ejercicio de los derechos individuales y colectivos”

                        </p>

                    </article>

                </div>

            </div>

        </section>

    );

};

export default Sellos;